import client from "../api/client";
export const getList = () => {
  return client('/api/bank-accounts').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/bank-accounts/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/bank-accounts/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/bank-accounts', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/bank-accounts/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useBankAccountService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel,
  };
}
